<template>
  <div>
    Stripe
  </div>
</template>

<script>
export default {
  name: 'AdminSettingsStripe',
  data: () => ({
    loading: true
  })
}
</script>